// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner_loader__2r1Cs"};